import { shopifyClient } from './shopify.client';

class ShopifyProductService {
  lookupProduct() {
    const pathname = window.location.pathname;

    if (!pathname.includes('/products/')) {
      return Promise.resolve(null);
    }

    const pathSegments = pathname.split('/');
    const handle = pathSegments[pathSegments.length - 1];

    if (!handle) {
      return Promise.resolve(null);
    }

    return shopifyClient.getProduct(handle);
  }
}

// Create singleton instance
export const shopifyProductService = new ShopifyProductService();
